import type { FilterTypes, IFilterSelection } from 'types/aemui/find-a-location/findaLocation';

export const programs: IFilterSelection[] = [
	{ name: 'Group Training', value: '15', elementId: 'program-gt' },
	{ name: 'Kids Academy', value: '1', elementId: 'program-ka' },
	{ name: 'Personal Training', value: '14', elementId: 'program-pt' },
	{ name: 'Pickleball', value: '18', elementId: 'program-pickle' },
	{ name: 'Swim', value: '13', elementId: 'program-swim' },
	{ name: 'Yoga', value: '17', elementId: 'program-yoga' }
].map((s) => ({
	...s,
	type: 'program'
}));

export const additionalPrograms: IFilterSelection[] = [
	{ name: 'Adult Swim', value: '13', elementId: 'program-adult-swim' },
	{ name: 'Barre', value: '6', elementId: 'program-barre' },
	{ name: 'Basketball', value: '23', elementId: 'program-bball' },
	{ name: 'Birthday Parties', value: '4', elementId: 'program-birthday-parties' },
	{ name: 'Boxing & Kickboxing', value: '24', elementId: 'program-boxing-kickboxing' },
	{ name: 'Cycle', value: '7', elementId: 'program-cycle' },
	{ name: 'Group Fitness', value: '8', elementId: 'program-gf' },
	{ name: 'Kids Activities', value: '30', elementId: 'program-kids-activities' },
	{ name: 'Kids Camp', value: '2', elementId: 'program-kids-camp' },
	{ name: 'Kids Sports & Fitness', value: '5', elementId: 'program-kids-sports' },
	{ name: 'Kids Swim', value: '3', elementId: 'program-kids-swim' },
	{ name: 'Pilates', value: '9', elementId: 'program-pilates' },
	{ name: 'Racquetball', value: '19', elementId: 'program-racquet' },
	{ name: 'Rock Climbing', value: '11', elementId: 'program-rock' },
	{ name: 'Soccer', value: '28', elementId: 'program-soccer' },
	{ name: 'Squash', value: '20', elementId: 'program-squash' },
	{ name: 'Tennis', value: '22', elementId: 'program-tennis' }
].map((s) => ({
	...s,
	type: 'program'
}));

export const topServices: IFilterSelection[] = [
	{ name: 'Group Training', value: '21', elementId: 'service-gt' },
	{ name: 'Hair', value: '15', elementId: 'service-hair' },
	{ name: 'Kids Academy', value: '6', elementId: 'service-kids-academy' },
	{ name: 'Massage', value: '16', elementId: 'service-massage' },
	{ name: 'Personal Training', value: '31', elementId: 'service-pt' },
	{ name: 'Swim Lessons', value: '5', elementId: 'service-swim' }
].map((s) => ({
	...s,
	type: 'service'
}));

export const additionalServices: IFilterSelection[] = [
	{ name: 'Bar', value: '9', elementId: 'service-bar' },
	{ name: 'Basketball Training', value: '29', elementId: 'service-bball-train' },
	{ name: 'Birthday Parties', value: '1', elementId: 'service-birthday-parties' },
	{ name: 'Chiropractic & Rehabilitation', value: '13', elementId: 'service-randc' },
	{ name: 'Golf Instruction', value: '20', elementId: 'service-gi' },
	{ name: 'Infant Care', value: '3', elementId: 'service-child-center' },
	{ name: 'Kids Camp', value: '2', elementId: 'service-kids-camp' },
	{ name: 'LifeCafe', value: '7', elementId: 'service-lifecafe' },
	{ name: 'LifeCafe Poolside', value: '32', elementId: 'service-lp' },
	{ name: 'MediSpa', value: '17', elementId: 'service-medispa' },
	{ name: 'Nails', value: '18', elementId: 'service-nails' },
	{ name: 'Nutritional Coaching', value: '11', elementId: 'service-nc' },
	{ name: 'Skin', value: '19', elementId: 'service-skin' },
	{ name: 'Soccer Training', value: '25', elementId: 'service-st' },
	{ name: 'Squash Lessons', value: '24', elementId: 'service-squashl' },
	{ name: 'Swim Assessments', value: '4', elementId: 'service-swim-assessments' },
	{ name: 'Tennis Lessons', value: '22', elementId: 'service-tennisl' }
].map((s) => ({
	...s,
	type: 'service'
}));

export const topFeaturesAndAmenities: IFilterSelection[] = [
	{ name: 'Indoor Swimming Pool', value: '2', elementId: 'feature-indoor-spool' },
	{
		name: 'Outdoor Swimming Pool',
		value: '7',
		elementId: 'feature-outdoor-spool'
	},
	{ name: 'Infant Room', value: '37', elementId: 'feature-ir' },
	{ name: 'LifeSpa', value: '52', elementId: 'feature-lifespa' },
	{ name: 'Pickleball Court', value: '20', elementId: 'feature-pickle' },
	{ name: 'Rock Wall', value: '30', elementId: 'feature-cw' }
].map((s) => ({
	...s,
	type: 'feature'
}));

export const additionalFeaturesAndAmenities: IFilterSelection[] = [
	{ name: 'Advanced Training Studio', value: '58', elementId: 'feature-adv-ts' },
	{ name: 'Alpha Field', value: '12', elementId: 'feature-afield' },
	{ name: 'Arts & Crafts Studio', value: '32', elementId: 'feature-aandc' },
	{ name: 'Bar', value: '57', elementId: 'feature-bar' },
	{ name: 'Basketball Courts', value: '29', elementId: 'feature-bball-courts' },
	{ name: 'Boxing Gym', value: '59', elementId: 'feature-boxing-gym' },
	{
		name: 'Chiropractic & Rehabilitation',
		value: '48',
		elementId: 'feature-racc'
	},
	{ name: 'Computer Center', value: '35', elementId: 'feature-comp-center' },
	{ name: 'Dance & Yoga Studio', value: '36', elementId: 'feature-dandy' },
	{ name: 'Fitness Studios', value: '60', elementId: 'feature-fs' },
	{ name: 'Indoor Cycle Studio', value: '62', elementId: 'feature-ics' },
	{ name: 'Indoor Lap Pool', value: '1', elementId: 'feature-ilp' },
	{ name: 'Indoor Tennis Courts', value: '13', elementId: 'feature-itc' },
	{ name: 'Indoor Turf Field', value: '14', elementId: 'feature-itf' },
	{ name: 'Indoor Water Slide', value: '3', elementId: 'feature-iws' },
	{ name: 'Indoor Whirlpool', value: '4', elementId: 'feature-iw' },
	{ name: 'Junior Sport Court', value: '38', elementId: 'feature-jsc' },
	{ name: 'Karate & Tumble Studio', value: '39', elementId: 'feature-kats' },
	{ name: 'Kids Academy', value: '34', elementId: 'feature-kids-acad' },
	{ name: 'Lazy River', value: '5', elementId: 'feature-lr' },
	{ name: 'LifeCafe', value: '54', elementId: 'feature-lifecafe' },
	{ name: 'LifeCafe Poolside', value: '55', elementId: 'feature-lifecafe-pool' },
	{ name: 'MediSpa', value: '66', elementId: 'feature-medispa' },
	{ name: 'Outdoor Fitness Trail', value: '28', elementId: 'feature-oft' },
	{ name: 'Outdoor Lap Pool', value: '6', elementId: 'feature-olp' },
	{ name: 'Outdoor Play Area', value: '40', elementId: 'feature-opm' },
	{ name: 'Outdoor Tennis Courts', value: '15', elementId: 'feature-otc' },
	{ name: 'Outdoor Turf Field', value: '16', elementId: 'feature-otf' },
	{ name: 'Outdoor Water Slide', value: '8', elementId: 'feature-ows' },
	{ name: 'Outdoor Whirlpool', value: '9', elementId: 'feature-ow' },
	{ name: 'Pilates Studio', value: '64', elementId: 'feature-ps' },
	{ name: 'Play Maze', value: '41', elementId: 'feature-pm' },
	{ name: 'Pre School', value: '42', elementId: 'feature-preschool' },
	{ name: 'Racquetball Courts', value: '17', elementId: 'feature-racquet-courts' },
	{ name: 'Retail Store', value: '46', elementId: 'feature-rs' },
	{ name: 'Saunas', value: '51', elementId: 'feature-saunas' },
	{ name: 'Splash Pad', value: '10', elementId: 'feature-sp' },
	{ name: 'Squash Court', value: '19', elementId: 'feature-sc' },
	{ name: 'Steam Rooms', value: '53', elementId: 'feature-sr' },
	{
		name: 'Walking & Running Training Area',
		value: '26',
		elementId: 'feature-warta'
	},
	{ name: 'Yoga Studio', value: '65', elementId: 'feature-ys' },
	{ name: 'Zero Depth Entry Pool', value: '11', elementId: 'feature-zdep' }
].map((s) => ({
	...s,
	type: 'feature'
}));

/**
 * Given only what is stored in the URL query params, this finds and returns the
 * entire location filter including the name and elementId.
 *
 * @param type the type of the location filter
 * @param value the value of the location filter
 */
export function lookupFilter(type: FilterTypes, value: string) {
	const filterLookup = {
		program: [...programs, ...additionalPrograms],
		service: [...topServices, ...additionalServices],
		feature: [...topFeaturesAndAmenities, ...additionalFeaturesAndAmenities]
	};
	return filterLookup[type].find((filterSelection) => filterSelection.value === value);
}
